import axios from 'axios'

const FeedbackService = {
  checkInMinutes: 10,
  checkInTimer: null,

  async search (data) {
    return axios({
      url: axios.defaults.baseURL + 'feedback/search',
      method: 'POST',
      data: JSON.stringify(data)
    })
  },

  exportFeedback (params) {
    return axios.get('feedback/export', {
      params,
      responseType: 'blob'
    })
  },
  async getById (data) {
    return axios({
      url: axios.defaults.baseURL + 'feedback/transaction',
      method: 'POST',
      data: JSON.stringify(data)
    })
  },
  async getMany (data) {
    return axios({
      url: axios.defaults.baseURL + 'feedback/transactions',
      method: 'POST',
      data: JSON.stringify(data)
    })
  }
}

export default FeedbackService
